<template>
  <el-container class="base-container">
    <FaqPanel
      page="direct_deals"
      :top-offset="50"
      :max-width="350"
      :backdrop="true"
    />
    <el-main class="p-none">
      <FilterPanel v-model="filter" @refresh="update({})" />
      <LoadingBlock v-if="loading" :loading="true" />
      <el-row
        v-for="(rowItems, index) in chunk(items, itemsInRow[colClass])"
        v-else
        :key="index"
        :gutter="10"
        class="cards-row"
      >
        <el-col
          v-for="item in rowItems"
          :key="item.id"
          :xs="12"
          :sm="8"
          :md="6"
          :lg="4"
          :xl="4"
        >
          <FlatDealCard :item="item.attributes" />
        </el-col>
      </el-row>
      <Pagination
        class="mt-1"
        :total="total"
        :page="page"
        @pagination="update"
      />
    </el-main>
  </el-container>
</template>
<script lang="ts">
import { computed, ref, defineComponent } from 'vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { AdType } from '@/api/types'

import {
  IFlatDealFilter,
  IFlatDealPayload
} from '@/apps/traforama/interfaces/flatDeals'

import Pagination from '@/components/Pagination.vue'
import FlatDealCard from './components/FlatDealCard.vue'
import chunk from '@/utils/array'
import FilterPanel from './components/FilterPanel.vue'
import { useFlatDealsStore } from '@/apps/traforama/store/flatDeals'
import { useCountriesStore } from '@/store/modules/countries'
import useResize from '@/hooks/useResize'
import FaqPanel from '@/components/FaqPanel/Index.vue'

const LIMIT = 30

export default defineComponent({
  name: 'FlatDeals',
  components: {
    Pagination,
    FilterPanel,
    LoadingBlock,
    FlatDealCard,
    FaqPanel
  },
  setup(_props, context) {
    useCountriesStore().GetItems()
    const flatDealsStore = useFlatDealsStore()

    const loading = computed(
      () =>
        Object.keys(flatDealsStore.itemsLoading).length > 0 ||
        flatDealsStore.listLoading
    )
    const page = computed(() => flatDealsStore.currentPage)
    const items = computed(() => flatDealsStore.currentItems)
    const total = computed(() => flatDealsStore.total)
    const limit = ref(LIMIT)
    const filter = computed({
      get: () => flatDealsStore.filter,
      set: (val: IFlatDealFilter) => flatDealsStore.SetFilters(val)
    })

    const { isDesktop } = useResize()
    const { colClass } = useResize()

    const update = ({
      limit = 15,
      newPage = 1
    }: {
      limit?: number
      newPage?: number
    }) => {
      flatDealsStore.SetCurrentPage(newPage)
      flatDealsStore.FetchItems()
    }

    const showSizeColumn = computed(
      () => filter.value.type_id === AdType.Banner
    )
    const itemsInRow = { xs: 2, sm: 3, md: 4, lg: 6, xl: 6 }

    update({})

    return {
      loading,
      items,
      total,
      page,
      update,
      filter,
      showSizeColumn,
      isDesktop,
      chunk,
      colClass,
      itemsInRow
    }
  }
})
</script>
<style lang="scss" scoped>
.filter-container {
  padding-bottom: 0;
  .el-card__body {
    padding-bottom: 0;
  }
}
.padding-5 {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 25px;
}
:deep(.el-card.is-always-shadow) {
  box-shadow: none;
}
</style>
